function equalizeCards() {
    const rows = [];
    const tolerance = 10; // pixels

    // Group cards by their row position
    const cards = document.querySelectorAll('.card--product') || [];

    if (cards.length) {
        cards.forEach(card => {
            const cardTop = card.getBoundingClientRect().top;
            let row = rows.find(r => Math.abs(r.top - cardTop) <= tolerance);
            
            if (!row) {
                row = { 
                    top: cardTop, 
                    vendors: [], 
                    titles: [], 
                    ratings: [], 
                    prices: [] 
                };
                rows.push(row);
            }
            
            const vendor = card.querySelector('.card__vendor');
            const title = card.querySelector('.card__title');
            const rating = card.querySelector('.card__rating');
            const priceWrapper = card.querySelector('.card__price-wrapper');
            
            if (vendor) row.vendors.push(vendor);
            if (title) row.titles.push(title);
            if (rating) row.ratings.push(rating);
            if (priceWrapper) row.prices.push(priceWrapper);
        });
    }

    // Reset all heights first
    document.querySelectorAll('.card__vendor').forEach(v => v.style.minHeight = 'auto');
    document.querySelectorAll('.card__title').forEach(t => t.style.minHeight = 'auto');
    document.querySelectorAll('.card__rating').forEach(r => r.style.minHeight = 'auto');
    document.querySelectorAll('.card__price-wrapper').forEach(p => p.style.minHeight = 'auto');

    // Apply max height per row
    rows.forEach(row => {
        // Equalize vendors
        if (row.vendors.length > 0) {
            const maxVendorHeight = Math.max(...row.vendors.map(el => el.offsetHeight));
            row.vendors.forEach(el => el.style.minHeight = maxVendorHeight + 'px');
        }

        // Equalize titles
        if (row.titles.length > 0) {
            const maxTitleHeight = Math.max(...row.titles.map(el => el.offsetHeight));
            row.titles.forEach(el => el.style.minHeight = maxTitleHeight + 'px');
        }
        
        // Equalize ratings (only if reviews exist)
        if (row.ratings.length > 0) {
            const hasReviews = row.ratings.some(rating => rating.querySelector('.categoryStarsMain'));
            if (hasReviews) {
                const maxRatingHeight = Math.max(...row.ratings.map(el => el.offsetHeight));
                row.ratings.forEach(el => el.style.minHeight = maxRatingHeight + 'px');
            }
        }
        
        // Equalize price wrappers
        if (row.prices.length > 0) {
            const maxPriceHeight = Math.max(...row.prices.map(el => el.offsetHeight));
            row.prices.forEach(el => el.style.minHeight = maxPriceHeight + 'px');
        }
    });
}

// Run on initial load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalizeCards);
} else {
    equalizeCards();
}

// Run when cart recommendations are loaded
document.addEventListener('product-recommendations:loaded', function() {
    setTimeout(equalizeCards, 150);
});

// Run when recently viewed products are loaded
document.addEventListener('recently-viewed:loaded', function() {
    setTimeout(equalizeCards, 150);
});

// Run after images are loaded (for dynamic content)
window.addEventListener('load', function() {
    setTimeout(equalizeCards, 200);
});

// Re-run on window resize
let resizeTimeout;
window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(equalizeCards, 250);
});
